import { formatValuePercent } from "@/components/widgets/helpers/FormattingHelpers";

export function formatPositivePercentValue(
	value: number | undefined | null,
): string {
	if (value == null || Number.isNaN(value)) return "";

	const sign = value > 0 ? "+" : "";
	return `${sign}${formatValuePercent(value)}`;
}
